import React from 'react';
import useAccess from '../../hooks/useAccess';

/**
 * Old style:  <RequirePermission module="users" action="create">...</RequirePermission>
 * New style:  <RequirePermission do="users.create">...</RequirePermission>
 * Hidden (fallback) when there is no access.
 */
const RequirePermission = ({ module, action = 'view', do: key, any, children, fallback = null }) => {
  const { can, canAny } = useAccess();
  const needKey = key || (module ? `${module}.${action}` : null);
  const ok = (!needKey || can(needKey)) && (!any || canAny(any));
  return ok ? <>{children}</> : fallback;
};

export default RequirePermission;